module finadai.services{
  import Granter = finadai.models.Granter;
  export class GrantersService {
    static instanceName = "grantersService";
    constructor(private $http: ng.IHttpService, private proxifier, private $httpParamSerializer: ng.IHttpParamSerializer){

    }
    save(data: any, id?): ng.IHttpPromise<Granter>{
      // data = this.$httpParamSerializer(data)
      if(angular.isDefined(data.id)) id = data.id
      if(angular.isUndefined(id)){
        return this.$http.post([this.proxifier(), 'finadai', 'granters'].join('/'), data);
      }
      return this.$http.put([this.proxifier(), 'finadai', 'granters', id].join('/'), data);
    }
    get(id?): ng.IHttpPromise<any>{
      if(angular.isUndefined(id)){
        return this.$http.get([this.proxifier(), 'finadai', 'granters'].join('/'), { params: { page: 1, limit: 2000 } });
      }
      return this.$http.get([this.proxifier(), 'finadai', 'granters', id].join('/'));
    }
    remove(id){
      return this.$http.delete([this.proxifier(), 'finadai', 'granters', id].join('/'));
    }
  }
}